import { styled } from '@mui/material/styles';
import { Skeleton } from '@mui/material';
import { Column, Row } from 'components/Layout';

const SkeletonContainer = styled(Column)(({ theme }) => ({
  padding: theme.spacing(theme.spacingSizes.sm),
  gap: theme.spacing(theme.spacingSizes.sm),
}));

const SkeletonTabBar = styled(Row)(({ theme }) => ({
  gap: theme.spacing(theme.spacingSizes.sm),
  borderBottom: `1px solid ${theme.palette.divider}`,
  paddingBottom: theme.spacing(theme.spacingSizes.sm),
}));

const SkeletonRow = styled(Row)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(theme.spacingSizes.sm),
}));

const RevaluationRowSkeleton: React.FC = () => (
  <SkeletonContainer>
    <SkeletonTabBar>
      <Skeleton variant="text" width={180} />
      <Skeleton variant="text" width={160} />
    </SkeletonTabBar>
    <SkeletonRow>
      <Skeleton variant="text" width="25%" />
      <Skeleton variant="text" width="25%" />
      <Skeleton variant="text" width="25%" />
      <Skeleton variant="text" width="25%" />
    </SkeletonRow>
    <SkeletonRow>
      <Skeleton variant="text" width="25%" />
      <Skeleton variant="text" width="25%" />
      <Skeleton variant="text" width="25%" />
      <Skeleton variant="text" width="25%" />
    </SkeletonRow>
    <SkeletonRow>
      <Skeleton variant="text" width="25%" />
      <Skeleton variant="text" width="25%" />
      <Skeleton variant="text" width="25%" />
      <Skeleton variant="text" width="25%" />
    </SkeletonRow>
    <SkeletonRow>
      <Skeleton variant="text" width="25%" />
      <Skeleton variant="text" width="25%" />
      <Skeleton variant="text" width="25%" />
      <Skeleton variant="text" width="25%" />
    </SkeletonRow>
  </SkeletonContainer>
);

export default RevaluationRowSkeleton;
